// tslint:disable-next-line export-name
import json from "@apps/mf-overview/src/locales/da-dk.json";

export const messages = {
  ...json,

  formats: {
    date: {
      short: {
        literal: ".",
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }
    }
  },
} as const;
